import { render, staticRenderFns } from "./support-modal.vue?vue&type=template&id=5a72fc3c&scoped=true&"
import script from "./support-modal.vue?vue&type=script&lang=ts&"
export * from "./support-modal.vue?vue&type=script&lang=ts&"
import style0 from "./support-modal.vue?vue&type=style&index=0&id=5a72fc3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a72fc3c",
  null
  
)

export default component.exports